<template>
  <v-app id="ilab">
    <main-menu v-if="currentUser && hasCurrentRole" :activeMainMenu.sync="activeMainMenu"/>

    <v-navigation-drawer
      v-if="commentAside"
      v-model="commentAside"
      absolute
      temporary
      right
      class="commentAside"
      @input="addClassForDocument"
    >
      <comments
        class="elevation-0"
        v-bind="commentAsideState"
      />
    </v-navigation-drawer>

    <v-toolbar app absolute color="success lighten-3">

        <v-toolbar-side-icon v-if="currentUser && hasCurrentRole" @click.prevent="toggleMainMenuActive">
          <v-badge color="red" overlap>
            <template v-slot:badge>
              <template v-if="unreadCounter > 0">
                <span class="caption">{{ unreadCounter }}</span>
              </template>
            </template>
            <v-icon>menu</v-icon>
          </v-badge>
        </v-toolbar-side-icon>

      <v-toolbar-title class="headline">
        <router-link class="logo" :to="{ name: allRoutes.home.name }">
          <strong class="text-uppercase">i-Lab</strong>
          <span> R&I Database</span>
        </router-link>
      </v-toolbar-title>
      <v-spacer/>
      <v-layout justify-end row>
        <v-flex align-self-end xs10 md5 v-if="userGroups.length">
          <v-select v-model="currentGroup" :items="userGroups" :item-text="'name'" :item-value="'id'"
                    label="Роль" hide-details class="pa-0" return-object></v-select>
        </v-flex>
        <v-flex align-self-baseline shrink>
          <v-btn color="success" @click="logout" small icon v-if="isAuthorized">
            <v-icon small>
              logout
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-toolbar>

    <v-content>
      <v-container fluid>
        <router-view v-if="!isShowNoRole"/>

        <v-layout v-if="isShowNoRole" row wrap align-center justify-center>
          <v-flex xs12>
            <v-card>
              <v-card-title>
                <h1>Доступ запрещен</h1>
              </v-card-title>

              <v-card-text>
                <h2>Вам не задано ни одной роли, обратитесь к администратору.</h2>
              </v-card-text>

            </v-card>
          </v-flex>
        </v-layout>

      </v-container>
    </v-content>

    <v-footer inset app>
      <span class="px-3">&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>

    <page-loading-spinner/>
    <dialog-alert/>
  </v-app>
</template>

<script>
import mainMenu from './components/menu/mainMenu';
import pageLoadingSpinner from './components/loading/pageLoadingSpinner';
import dialogAlert from './components/alert/dialogAlert';
import CurrentUser from './orm/models/CurrentUser';
import STORE from './store/STORE';
import {mapState} from "vuex";
import {API} from "@/utils/api";

const { actions: currentUserActions } = STORE.modules.currentUser;

export default {
  name: 'Ilab',
  data: function() {
    return {
      activeMainMenu: true,
      commentAside: false,
      commentAsideState: {
        module: 'GENERAL',
        id: this.$route.params.id,
        type: 'booking',
        uniqueId: '',
      },
    };
  },
  provide() {
    return {
      showCommentAside: this.toggleCommentAside,
    };
  },
  computed: {
    ...mapState('notifications', ['unreadCounter']),
    hasCurrentRole() {
      return this.currentGroup.slug && this.currentGroup.slug.length > 0;
    },
    isShowNoRole() {
      return !this.hasCurrentRole && this.$route.meta.public !== true;
    }
  },
  methods: {
    addClassForDocument() {
      document.documentElement.classList.toggle('overflow');
      // document.body.classList.toggle('overflow');
    },
    toggleMainMenuActive() {
      this.activeMainMenu = !this.activeMainMenu;
    },
    async logout() {
      // await CurrentUser.dispatch(`${ currentUserActions.logout }`);
      // this.$router.push({ name: 'login' });

      try {
        await API.get('/sso/local_sls')
      } finally {
        await API.get('/sso/create_logout_link/').then(responce => {
          window.location = responce.data.logout_link;
        })
      }
    },
    toggleCommentAside(commentState) {
      Object.assign(this.commentAsideState, commentState);
      this.commentAside = true;
    },
  },
  components: {
    mainMenu,
    pageLoadingSpinner,
    dialogAlert,
    comments: () => import('./components/comments/comments'),
  },
};
</script>

<style>
.logo {
  text-decoration: none;
  color: initial;
}

.overflow {
  height: 100%;
  overflow: hidden;
}

.commentAside {
  position: fixed;
}
</style>
